import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.link/vk721m';
function WhatsAppIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true" data-id="element-314">
      <path d="M16 3.2a12.8 12.8 0 0 0-10.93 19.47L3.2 28.8l6.29-1.64A12.8 12.8 0 1 0 16 3.2Zm0 23.23a10.4 10.4 0 0 1-5.3-1.45l-.38-.23-3.86 1 1.03-3.77-.25-.4a10.4 10.4 0 1 1 8.78 4.85Zm5.7-7.8c-.31-.16-1.85-.91-2.14-1.02-.29-.1-.5-.16-.7.16-.21.32-.81 1.02-.99 1.23-.18.21-.37.24-.68.08-.32-.16-1.33-.49-2.53-1.55-.93-.83-1.56-1.86-1.74-2.18-.18-.31-.02-.48.14-.64l.47-.55c.16-.18.21-.31.31-.52.11-.21.06-.39-.02-.55-.08-.16-.7-1.7-.96-2.33-.25-.61-.51-.52-.7-.53h-.6c-.21 0-.55.08-.84.39-.29.32-1.1 1.07-1.1 2.61 0 1.54 1.12 3.02 1.28 3.23.16.21 2.21 3.37 5.35 4.73.75.32 1.33.51 1.79.66.75.24 1.43.2 1.97.12.6-.09 1.85-.76 2.11-1.49.26-.73.26-1.35.18-1.49-.08-.13-.29-.21-.6-.36Z" data-id="element-315" />
    </svg>;
}
export function WhatsAppFloat() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setIsOpen(true), 5000);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex flex-col items-end gap-3" data-id="element-316">
      <AnimatePresence data-id="element-317">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: 'easeOut'
      }} className="relative w-[250px] rounded-2xl rounded-br-md border border-clinical-line bg-white px-4 py-3.5 pr-9 shadow-[0_14px_36px_rgba(11,42,74,0.2)]" role="dialog" aria-label="Ayuda por WhatsApp" data-id="element-318">
            <button type="button" onClick={() => setIsOpen(false)} aria-label="Cerrar mensaje de WhatsApp" className="absolute right-2.5 top-2.5 rounded-md p-1 text-clinical-ink/40 transition-colors hover:text-clinical-deep focus:outline-none focus:ring-2 focus:ring-clinical-mid/40" data-id="element-319">
              <X className="h-4 w-4" data-id="element-320" />
            </button>
            <p className="text-[13px] leading-snug text-clinical-ink" data-id="element-321">
              ¿Tenés alguna duda?{' '}
              <span className="font-bold text-clinical-deep" data-id="element-322">
                Escribinos por WhatsApp.
              </span>
            </p>
            <a href={WHATSAPP_LINK} target="_top" className="mt-2.5 inline-flex items-center gap-1.5 text-xs font-bold text-[#168a46] transition-colors hover:text-[#0f6d37]" data-id="element-323">
              <WhatsAppIcon className="h-3.5 w-3.5" data-id="element-324" />
              Chatear ahora
            </a>
          </motion.div>}
      </AnimatePresence>

      <motion.a href={WHATSAPP_LINK} target="_top" aria-label="Contactar por WhatsApp" initial={{
      opacity: 0,
      scale: 0.85
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.45,
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_28px_rgba(37,211,102,0.42)] transition-transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#25D366]/30" data-id="element-325">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 pointer-events-none" data-id="element-326" />
        <WhatsAppIcon className="relative h-7 w-7" data-id="element-327" />
      </motion.a>
    </div>;
}